module.exports = __webpack_public_path__ + "img/05—Applications—Parental Control Collapsed.2b5b7eca.jpg";